import {MI} from "../init.js";

/**
 * @constructor
 * @returns {FsFires}
 */
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";

export function FsFires() {

	/** @type {MadnesGroup} */
	this._group;

	/** @type {MadnesObject} */
	this._fsFireBgLeft;
	/** @type {MadnesObject} */
	this._fsFireBgRight;
	/** @type {MadnesObject} */
	this._fsFireBgCenter;

	/** @type {Array<MadnesTween>} */
	this._tweens = [];
};

/**
 * @param {MadnesGroup} group
 * @param {number=} xAdd
 * @param {number=} yAdd
 * @param {number=} offset
 * @param {number=} scale
 */
FsFires.prototype.create = function(group, xAdd, yAdd, offset, scale) {

	this._group = group;

	var xadd = typeof xAdd !== "undefined" ? xAdd : 0;
	var yadd = typeof yAdd !== "undefined" ? yAdd : -50;

	var sc = typeof scale !== "undefined" ? scale : 2;

	var off = typeof offset !== "undefined" ? offset : 210;

	this._fsFireBgLeft = this._createFsFireBg(xadd + 640 + off, he / 2 + yadd, sc, sc, 1, 0.5, 0);
	this._group.add(this._fsFireBgLeft);
	this._fsFireBgRight = this._createFsFireBg(xadd + 640 - off, he / 2 + yadd, sc, sc, 0, 0.5, 0);
	this._group.add(this._fsFireBgRight);
	this._fsFireBgCenter = this._createFsFireBg(xadd + wi / 2, he / 2 + yadd, sc, sc, 0.5, 0.5, 0);
	this._group.add(this._fsFireBgCenter);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {number} sX
 * @param {number} sY
 * @param {number} aX
 * @param {number} aY
 * @param {number} a
 * @returns {MadnesObject}
 */
FsFires.prototype._createFsFireBg = function(x, y, sX, sY, aX, aY, a) {
	var bg = MI.addImg(x, y, "fire_fs_bg_atlas");
	bg.createAnims();
	bg.anims.add("fire", MI.randomizeFrames(MI.generateFrameNames("fire_free-spins_background_", 0, 17, "", 5)));
	bg.setScale(sX, sY);
	bg.setAnchor(aX, aY);
	bg.setAlpha(a);

	return bg;
};

FsFires.prototype.run = function(callback) {
//	var _self = this;

	this._fsFireBgCenter.anims.loop("fire");
	this._fsFireBgLeft.anims.loop("fire");
	this._fsFireBgRight.anims.loop("fire");

//	MI.addTween().to(this.fsFireBgCenter, { 'x': 2, 'y': 2 }, {
//		'scale': true,
//		'duration': 400
//	});

	var t = MI.addTween().to(this._fsFireBgCenter, { 'alpha': 1 }, {
		//'delay': 100,
		'duration': 400
	});
	this._tweens.push(t);


//	MI.addTween().to(this.fsFireBgLeft, { 'x': 2, 'y': 2 }, {
//		'scale': true,
//		//'delay': 200,
//		'duration': 500
//	});

	t = MI.addTween().to(this._fsFireBgLeft, { 'alpha': 1 }, {
		//'delay': 200,
		'duration': 700
	});
	this._tweens.push(t);

//	MI.addTween().to(this.fsFireBgRight, { 'x': 2, 'y': 2 }, {
//		'scale': true,
//		//'delay': 200,
//		'duration': 500
//	});

	t = MI.addTween().to(this._fsFireBgRight, { 'alpha': 1 }, {
		//'delay': 200,
		'duration': 700,
		'callback': callback
	});
	this._tweens.push(t);
};

FsFires.prototype.hide = function() {

	var _self = this;

	return new Promise(function(res) {

	//	MI.addTween().to(this.fsFireBgCenter, { 'x': 0, 'y': 0 }, {
	//		'scale': true,
	//		'duration': 400,
	//		'delay': 200
	//	});

		var t = MI.addTween().to(_self._fsFireBgCenter, { 'alpha': 0 }, {
			//'delay': 200,
			'duration': 600
		});
		_self._tweens.push(t);

	//	MI.addTween().to(this.fsFireBgLeft, { 'x': 0, 'y': 0 }, {
	//		'scale': true,
	//		'duration': 400
	//	});

		t = MI.addTween().to(_self._fsFireBgLeft, { 'alpha': 0 }, {
			'duration': 400
		});
		_self._tweens.push(t);

	//	MI.addTween().to(this.fsFireBgRight, { 'x': 0, 'y': 0 }, {
	//		'scale': true,
	//		'duration': 400
	//	});

		t = MI.addTween().to(_self._fsFireBgRight, { 'alpha': 0 }, {
			'duration': 400,
			'callback': res
//			'callback': function() {
//				_self._destroy();
//			}
		});
		_self._tweens.push(t);

	});
};

FsFires.prototype._destroy = function() {
	this._fsFireBgLeft.destroy();
	this._fsFireBgLeft = null;

	this._fsFireBgRight.destroy();
	this._fsFireBgRight = null;

	this._fsFireBgCenter.destroy();
	this._fsFireBgCenter = null;
};

FsFires.prototype.destroy = function() {

	for(var i = 0; i < this._tweens.length; i++)
	{
		this._tweens[i].destroy();
	}

	this._tweens.length = 0;

	this._destroy();
};